<form class="component-container special-appliance-container" *ngIf="districtHeatDeviceFG" [formGroup]="districtHeatDeviceFG">
  <app-custom-fields formControlName="customFields" [applicationSection]="applicationSection" [isReadOnly]="isReadOnly"></app-custom-fields>
</form>
